/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <b-modal
      v-model="isVisible"
      id="package-discounts-list-modal"
      :title="title"
      title-class="font-18 fw-bold text-primary"
      header-class="bg-light-gray"
      size="xl"
      hide-footer
      body-class="p-0"
      scrollable
  >
    <div class="manager-wrapper">
      <PackageDiscountsListPanel
          class="p-3"
          :currentPackageOrder="currentPackageOrder"
          :wholesaler="wholesaler"
          :includeAll="includeAll"
          :wholesalerSelectBoxVisible="wholesalerSelectBoxVisible"
          @onPackageDiscountSave="handleDiscountSave"
          @onPackageDiscountDelete="onPackageDiscountDelete"
      />
    </div>

    <div class="modal-footer-custom bg-light p-2 border-top text-end">
      <button class="btn btn-secondary px-4" @click="isVisible = false">Zamknij</button>
    </div>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue-next";
import PackageDiscountsListPanel from "./PackageDiscountsListPanel.vue"; // Upewnij się, że ścieżka jest poprawna

export default {
  name: "PackageDiscountsListModal",
  components: {
    BModal,
    PackageDiscountsListPanel
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    // Obiekt zamówienia, dla którego zarządzamy rabatami
    currentPackageOrder: {
      type: Object,
      required: true
    },
    wholesaler:{
      type: Object,
      default: null,
    },
    includeAll: {
      type: Boolean,
      default: false
    },
    wholesalerSelectBoxVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:showModal", "onPackageDiscountSave"],
  computed: {
    isVisible: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.$emit("update:showModal", val);
      },
    },
    title() {
      return this.wholesaler ? "Zarządzanie rabatami pakietowymi dla hurtowni" : "Zarządzanie rabatami pakietowymi";
    }
  },
  methods: {
    handleDiscountSave(event) {
      // Przekazujemy zdarzenie wyżej (np. żeby odświeżyć widok główny zamówienia)
      this.$emit("onPackageDiscountSave",event);
    },
    onPackageDiscountDelete(event){
      this.$emit("onPackageDiscountDelete",event)
    }
  }
};
</script>

<style scoped>
.bg-light-gray {
  background-color: #f3f2f1;
}

/* Ustawiamy sztywną wysokość dla kontenera wewnątrz modala */
.manager-wrapper {
  height: 80vh;
  min-height: 500px;
  overflow: hidden;
}
</style>